import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { MobileDetectorService } from 'src/app/services/mobileDetector/mobile-detector.service';

@Component({
  selector: 'app-groups-main',
  templateUrl: './groups-main.component.html',
  styleUrls: ['./groups-main.component.scss']
})
export class GroupsMainComponent implements OnInit {

  @Output() toggleOptionEvent = new EventEmitter<number>();

  showNew: boolean = false;
  isMobile: boolean = false;
  constructor(
    private mobileDetectorService: MobileDetectorService
  ) { }

  ngOnInit(): void {
    this.isMobile = this.mobileDetectorService.isMobile();
  }

  toggleNew() {
    this.showNew = !this.showNew;
  }

  toggleOption(option: number) {
    this.toggleOptionEvent.emit(option);
  }

}
